import React from 'react';
import Provider from './Provider';
import FullCard from '../../../../../components/Card/FullCard';
import Form from './Form';
import List from './List';
import Buttons from './Buttons';
import { makeStyles } from '@material-ui/core/styles';
import useTitle from 'hooks/useTitle';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridGap: theme.spacing(1),
  },
}));

const AddBasePrice = () => {
  useTitle('افزودن کرایه حمل')
  const classes = useStyles();
  return (
    <Provider>
      <FullCard
        title="افزودن کرایه حمل"
        category="جهت افزودن کرایه حمل های عرفی موجود"
        actions={<Buttons />}
      >
        <div className={classes.root}>
          <Form />
          <List />
        </div>
      </FullCard>
    </Provider>
  );
};

export default React.memo(AddBasePrice);
